__turbopack_context__.v({
  "adornment": "rounded-module-scss-module__FnKsVq__adornment",
  "container": "rounded-module-scss-module__FnKsVq__container",
  "container-medium": "rounded-module-scss-module__FnKsVq__container-medium",
  "container-small": "rounded-module-scss-module__FnKsVq__container-small",
  "container-with-error": "rounded-module-scss-module__FnKsVq__container-with-error",
  "displayOnLight": "rounded-module-scss-module__FnKsVq__displayOnLight",
  "error": "rounded-module-scss-module__FnKsVq__error",
  "input": "rounded-module-scss-module__FnKsVq__input",
  "input-small": "rounded-module-scss-module__FnKsVq__input-small",
  "input-with-adornment": "rounded-module-scss-module__FnKsVq__input-with-adornment",
  "input-with-error": "rounded-module-scss-module__FnKsVq__input-with-error",
  "label": "rounded-module-scss-module__FnKsVq__label",
  "label-with-error": "rounded-module-scss-module__FnKsVq__label-with-error",
  "responsive-image": "rounded-module-scss-module__FnKsVq__responsive-image",
});
